// Form submission is intentionally NOT wired to a real backend in this
// build — per the brief, this marketing site must never process
// payments, expose secret keys, or send email directly from the
// browser. Set VITE_FORM_ENDPOINT to a server endpoint (a serverless
// function, WHMCS API proxy, or a form service) to make submissions
// real; until then, submitForm simulates success so the UI/UX can be
// reviewed and QA'd end-to-end.

export async function submitForm(payload: Record<string, unknown>): Promise<void> {
  const endpoint = import.meta.env.VITE_FORM_ENDPOINT;

  if (!endpoint) {
    await new Promise((resolve) => setTimeout(resolve, 700));
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.info("[forms] no VITE_FORM_ENDPOINT set — simulated submit:", payload);
    }
    return;
  }

  const res = await fetch(endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    throw new Error(`Form submission failed with status ${res.status}`);
  }
}
